/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * Prompt feature payload.
 */
export type HookPromptData = {
  /**
   * User prompt text.
   */
  text?: string | undefined;
};

/** @internal */
export type HookPromptData$Outbound = {
  text?: string | undefined;
};

/** @internal */
export const HookPromptData$outboundSchema: z.ZodMiniType<
  HookPromptData$Outbound,
  HookPromptData
> = z.object({
  text: z.optional(z.string()),
});

export function hookPromptDataToJSON(hookPromptData: HookPromptData): string {
  return JSON.stringify(HookPromptData$outboundSchema.parse(hookPromptData));
}
